import { useLoad } from "@redotech/react-util/load";
import { memo, useContext } from "react";
import { OnboardingV2RpcClientContext } from "../rpc-client";

function getReturnPath(): string {
  try {
    const state = new URLSearchParams(window.location.search).get("state");
    if (!state) {
      return "/";
    }
    const decoded = new TextDecoder().decode(
      new Uint8Array(
        (state.match(/.{1,2}/g) ?? []).map((byte) => parseInt(byte, 16)),
      ),
    );
    return new URLSearchParams(decoded).get("returnPath") ?? "/";
  } catch {
    return "/";
  }
}

export const ShopifyOAuthCallback = memo(function ShopifyOAuthCallback() {
  const rpcClient = useContext(OnboardingV2RpcClientContext);
  const returnPath = getReturnPath();

  const load = useLoad(async () => {
    if (!rpcClient) {
      return;
    }

    const url = new URL(window.location.href);
    const params = Object.fromEntries(url.searchParams.entries());

    const { code, shop, hmac, state } = params;
    if (!code || !shop || !hmac || !state) {
      window.location.href = returnPath;
      return;
    }

    const result = await rpcClient.exchangeShopifyOAuthCode({
      code,
      shop,
      hmac,
      state,
      rawParams: params,
    });

    if (result.redirectUrl) {
      window.location.href = result.redirectUrl;
    } else {
      window.location.href = returnPath;
    }
  }, [rpcClient, returnPath]);

  if (load.error) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          fontFamily: "system-ui, sans-serif",
          gap: "var(--redo-spacing-xl)",
        }}
      >
        <p style={{ color: "#dc2626" }}>
          Something went wrong updating permissions.
        </p>
        <a href={returnPath} style={{ color: "#2563eb" }}>
          Go back and try again
        </a>
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        fontFamily: "system-ui, sans-serif",
        color: "var(--redo-colors-text-text-tertiary)",
      }}
    >
      Updating permissions...
    </div>
  );
});

export default ShopifyOAuthCallback;
